// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Body lock when modal is open */
body.ad-body-locked {
  overflow: hidden !important;
  padding-right: 15px; /* Prevent layout shift from scrollbar */
}

/* ==========================================
   OVERLAY - Bulletproof full-screen coverage
   ========================================== */
.ad-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  padding: 20px;
  box-sizing: border-box;
  /* Ensure it's not affected by parent transforms */
  transform: none !important;
  isolation: isolate;
}

/* ==========================================
   MODAL
   ========================================== */
.ad-modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 500px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  animation: ad-slideUp 0.3s ease-out;
}

@keyframes ad-slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ==========================================
   HEADER
   ========================================== */
.ad-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.ad-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.ad-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;
}

.ad-close:hover {
  color: #374151;
}

/* ==========================================
   CONTENT
   ========================================== */
.ad-content {
  padding: 24px;
}

/* Icon */
.ad-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}

.ad-icon svg {
  width: 100%;
  height: 100%;
}

.ad-icon-danger {
  color: #dc2626;
}

.ad-icon-warning {
  color: #f59e0b;
}

.ad-icon-info {
  color: #6366f1;
}

/* Titles */
.ad-title {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #dc2626;
}

.ad-title-warning {
  color: #f59e0b;
}

/* Text */
.ad-text {
  margin: 0 0 16px 0;
  color: #4b5563;
  line-height: 1.6;
  font-size: 14px;
}

.ad-text-small {
  font-size: 13px;
  color: #6b7280;
  margin-top: 8px;
}

/* Warning box */
.ad-warning-box {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #92400e;
}

.ad-warning-box strong {
  color: #dc2626;
}

/* Info box */
.ad-info-box {
  background: #f3f4f6;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.ad-info-box p {
  margin: 0;
  color: #374151;
  line-height: 1.6;
}

.ad-info-box strong {
  color: #111827;
}

/* Status header */
.ad-status-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.ad-status-header .ad-icon {
  width: 28px;
  height: 28px;
  margin: 0;
  flex-shrink: 0;
}

.ad-status-header .ad-title {
  margin: 0;
}

/* Confirm box */
.ad-confirm-box {
  background: #fff;
  border: 2px solid #dc2626;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
}

.ad-confirm-box .ad-icon {
  margin: 0 auto 16px;
}

.ad-confirm-box .ad-title {
  text-align: center;
}

.ad-confirm-box .ad-text {
  text-align: center;
}

.ad-confirm-box-info {
  border-color: #6366f1;
}

.ad-confirm-box-info .ad-title {
  color: #374151;
}

/* ==========================================
   FORM
   ========================================== */
.ad-form-group {
  margin-bottom: 20px;
}

.ad-form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.ad-form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.ad-form-group textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

/* ==========================================
   BUTTONS
   ========================================== */
.ad-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.ad-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.ad-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ad-btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

.ad-btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}

.ad-btn-danger {
  background: #dc2626;
  color: #fff;
}

.ad-btn-danger:hover:not(:disabled) {
  background: #b91c1c;
}

.ad-btn-primary {
  background: #6366f1;
  color: #fff;
}

.ad-btn-primary:hover:not(:disabled) {
  background: #4f46e5;
}

/* ==========================================
   RESPONSIVE
   ========================================== */
@media (max-width: 640px) {
  .ad-overlay {
    padding: 16px;
  }

  .ad-modal {
    max-height: calc(100vh - 32px);
  }

  .ad-header {
    padding: 16px 20px;
  }

  .ad-content {
    padding: 20px;
  }

  .ad-buttons {
    flex-direction: column-reverse;
  }

  .ad-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AccountDeletion.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;;+CAE+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;+CAE+C;AAC/C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+CAE+C;AAC/C;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Body lock when modal is open */\nbody.ad-body-locked {\n  overflow: hidden !important;\n  padding-right: 15px; /* Prevent layout shift from scrollbar */\n}\n\n/* ==========================================\n   OVERLAY - Bulletproof full-screen coverage\n   ========================================== */\n.ad-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999999;\n  padding: 20px;\n  box-sizing: border-box;\n  /* Ensure it's not affected by parent transforms */\n  transform: none !important;\n  isolation: isolate;\n}\n\n/* ==========================================\n   MODAL\n   ========================================== */\n.ad-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 500px;\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  animation: ad-slideUp 0.3s ease-out;\n}\n\n@keyframes ad-slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ==========================================\n   HEADER\n   ========================================== */\n.ad-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.ad-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.ad-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.ad-close:hover {\n  color: #374151;\n}\n\n/* ==========================================\n   CONTENT\n   ========================================== */\n.ad-content {\n  padding: 24px;\n}\n\n/* Icon */\n.ad-icon {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 16px;\n}\n\n.ad-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.ad-icon-danger {\n  color: #dc2626;\n}\n\n.ad-icon-warning {\n  color: #f59e0b;\n}\n\n.ad-icon-info {\n  color: #6366f1;\n}\n\n/* Titles */\n.ad-title {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.ad-title-warning {\n  color: #f59e0b;\n}\n\n/* Text */\n.ad-text {\n  margin: 0 0 16px 0;\n  color: #4b5563;\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.ad-text-small {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 8px;\n}\n\n/* Warning box */\n.ad-warning-box {\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  color: #92400e;\n}\n\n.ad-warning-box strong {\n  color: #dc2626;\n}\n\n/* Info box */\n.ad-info-box {\n  background: #f3f4f6;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.ad-info-box p {\n  margin: 0;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.ad-info-box strong {\n  color: #111827;\n}\n\n/* Status header */\n.ad-status-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.ad-status-header .ad-icon {\n  width: 28px;\n  height: 28px;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.ad-status-header .ad-title {\n  margin: 0;\n}\n\n/* Confirm box */\n.ad-confirm-box {\n  background: #fff;\n  border: 2px solid #dc2626;\n  border-radius: 8px;\n  padding: 24px;\n  text-align: center;\n}\n\n.ad-confirm-box .ad-icon {\n  margin: 0 auto 16px;\n}\n\n.ad-confirm-box .ad-title {\n  text-align: center;\n}\n\n.ad-confirm-box .ad-text {\n  text-align: center;\n}\n\n.ad-confirm-box-info {\n  border-color: #6366f1;\n}\n\n.ad-confirm-box-info .ad-title {\n  color: #374151;\n}\n\n/* ==========================================\n   FORM\n   ========================================== */\n.ad-form-group {\n  margin-bottom: 20px;\n}\n\n.ad-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.ad-form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  box-sizing: border-box;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.ad-form-group textarea:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n/* ==========================================\n   BUTTONS\n   ========================================== */\n.ad-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.ad-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ad-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ad-btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.ad-btn-secondary:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.ad-btn-danger {\n  background: #dc2626;\n  color: #fff;\n}\n\n.ad-btn-danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.ad-btn-primary {\n  background: #6366f1;\n  color: #fff;\n}\n\n.ad-btn-primary:hover:not(:disabled) {\n  background: #4f46e5;\n}\n\n/* ==========================================\n   RESPONSIVE\n   ========================================== */\n@media (max-width: 640px) {\n  .ad-overlay {\n    padding: 16px;\n  }\n\n  .ad-modal {\n    max-height: calc(100vh - 32px);\n  }\n\n  .ad-header {\n    padding: 16px 20px;\n  }\n\n  .ad-content {\n    padding: 20px;\n  }\n\n  .ad-buttons {\n    flex-direction: column-reverse;\n  }\n\n  .ad-btn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
